import { Stack } from '@mui/material';

import BasetenLogo from '@/components/Icons/Logos/BasetenLogo';

function Header() {
  return (
    <Stack
      direction="column"
      justifyContent="start"
      alignItems="start"
      gap={8}
      px={5}
      pt={12}
      pb={5}
    >
      <BasetenLogo sx={{ width: 150, height: 46 }} />
    </Stack>
  );
}

export default Header;
